import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { HostelService } from 'src/app/private/services/hostel.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-hostel',
  imports: [SharedModule],
  templateUrl: './create-hostel.component.html',
  styleUrl: './create-hostel.component.scss'
})
export class CreateHostelComponent {

  @Input() type: string = 'Create';
  @Input() hostelData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  isSubmitted = false;
  btnLoading = false;

  hostelForm: FormGroup;

  loading = false;

  statusOptions = ["Active", "Inactive"];
  roomTypeOptions = ["Single", "Double", "Triple", "Dormitory"];
  currencyOptions = ["INR", "USD", "EUR"];

  facilitiesOptions = [
 { key: 'AC', label: 'Air Conditioning' },
  { key: 'WiFi', label: 'WiFi' },
  { key: 'Food', label: 'Food' },
  { key: 'Laundry', label: 'Laundry' },
  { key: 'Gym', label: 'Gym' },
  { key: 'StudyRoom', label: 'Study Room' },
  { key: 'Library', label: 'Library' },
  { key: 'Recreation', label: 'Recreation' },
  { key: 'Mess', label: 'Mess / Dining Hall' },
  { key: 'WaterCooler', label: 'Water Cooler' },
  { key: 'Parking', label: 'Parking Facility' },
  { key: '24HrSecurity', label: '24-Hour Security' },
  { key: 'CommonRoom', label: 'Common Room' },
  { key: 'TV', label: 'Television' },
  { key: 'CCTV', label: 'CCTV' },
  { key: 'Lift', label: 'Elevator' },
  { key: 'Medical', label: 'First Aid' },
  { key: 'Transport', label: 'Transport Facility' },
  { key: 'HotWater', label: 'Hot Water Supply' },
  { key: 'PowerBackup', label: 'Power Backup' },
  { key: 'Housekeeping', label: 'Housekeeping' },
  { key: 'EventHall', label: 'Event Hall' }
  ];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: HostelService,
    private localStorage: LocalStorageService
  ) {
    this.hostelForm = this.fb.group({
      hostel_name: ['', Validators.required],
      room_type: ['', Validators.required],
      capacity: ['', [Validators.required, Validators.min(1)]],
      fee_amount: ['', [Validators.required, Validators.min(0)]],
      currency: ['INR', Validators.required],
      facilities: this.fb.group({
        AC: [false],
        WiFi: [false],
        Food: [false],
        Laundry: [false],
        Gym: [false],
        StudyRoom: [false],
        Library: [false],
        Recreation: [false],
        Mess: [false],
        WaterCooler: [false],
        Parking: [false],
        '24HrSecurity': [false],
        CommonRoom: [false],
        TV: [false],
        CCTV: [false],
        Lift: [false],
        Medical: [false],
        Transport: [false],
        HotWater: [false],
        PowerBackup: [false],
        Housekeeping: [false],
        EventHall: [false]
      }),
      status: ['Active', Validators.required],
      organization_id: [this.localStorage.getOrganizationId() || ''],
      campus_id: [this.localStorage.getCampusId() || '']
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.hostelData) {
      console.log('Updating hostel with data:', this.hostelData);

      this.hostelForm.patchValue({
        hostel_name: this.hostelData.hostel_name,
        room_type: this.hostelData.room_type,
        capacity: this.hostelData.capacity,
        fee_amount: this.hostelData.fee_amount,
        currency: this.hostelData.currency,
        facilities: this.hostelData.facilities || {},
        status: this.hostelData.status,
        organization_id: this.hostelData.organization_id,
        campus_id: this.hostelData.campus_id
      });
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.hostelForm.valid) {
      const formValues = this.hostelForm.value;

      this.btnLoading = true;
      const payload = this.hostelForm.value;

      const apiCall = this.type === 'Create'
        ? this.api.createHostelCategory(payload)
        : this.api.updateHostelCategory({
          id: this.hostelData.id,
          ...payload
        });

      apiCall.subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `Hostel category ${this.type === 'Create' ? 'created' : 'updated'} successfully` });
          this.hostelForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.type.toLowerCase()} hostel category` });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fill all required fields' });
    }
  }
}
